import React, { useMemo } from 'react';
import ChartWidgetContainer from '@common/components/ChartWidgetContainer';

function TreeMapWidget({ widget }) {
  const { data } = widget;

  const option = useMemo(() => {
    if (!data || !Array.isArray(data)) return null;

    return {
      tooltip: {
        trigger: 'item',
        formatter: '{b}: {c}',
        confine: true,
        appendToBody: true,
      },
      series: [
        {
          name: widget.title,
          type: 'treemap',
          data: data.map((item) => ({
            name: item.name,
            value: item.value,
            itemStyle: {
              color: item.color || undefined,
            },
          })),
          roam: false,
          nodeClick: false,
          breadcrumb: {
            show: false,
          },
          label: {
            show: true,
            formatter: '{b}\n{c}',
            fontSize: 11,
          },
          itemStyle: {
            borderColor: '#fff',
            borderWidth: 2,
          },
          emphasis: {
            itemStyle: {
              shadowBlur: 10,
              shadowOffsetX: 0,
              shadowColor: 'rgba(0, 0, 0, 0.5)',
            },
          },
        },
      ],
    };
  }, [data, widget.title]);

  return <ChartWidgetContainer widget={widget} option={option} />;
}

export default TreeMapWidget;
